module.exports = __webpack_public_path__ + "img/10-10-2.f4ea33c0.jpg";